<!-- Outer wrapper with the same full-screen gradient background -->
<div class="flex items-center justify-center min-h-screen bg-gradient">

  <!-- “Card” container (mirrors the white box in your login screen) -->
  <div
    class="bs-bg-white rounded-lg p-8 w-full max-w-md"
    style="box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.25);">

    <!-- (Optional) Icon or heading above the main text
          <div class="flex justify-center mb-6">
            <img src="assets/images/errorIcon.png" alt="error icon" />
          </div>
    -->

    <!-- Main error message -->
    <h2 class="text-center text-lg font-normal text-black my-[30px]"
        [innerHTML]="errorMessage">
    </h2>


    <p class="flex items-center justify-center space-x-4 text-gray-700 text-base mb-[20px]">
      <button
        type="button"
        class="bs-btn bs-btn-sm bs-btn-primary bs-px-3"
        (click)="goBack()"
      >
        <i class="fa fa-arrow-circle-left"></i> Go Back
      </button>

      <button
        type="button"
        class="bs-btn bs-btn-sm bs-btn-secondary bs-px-3"
        (click)="goHome()"
      >
        <i class="fa fa-home"></i> Go Home
      </button>
    </p>

  </div>
</div>

